
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11418",
                "data-name": "矩形 11418",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(0.19 -0.19)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_355",
        "data-name": "蒙版组 355",
        "class": "cls-2",
        "transform": "translate(-0.19 0.19)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "reshuiqi",
            "class": "cls-3",
            "d": "M22.436,16.071a.518.518,0,1,1-1.024,0V12.5H16.8v3.571a.518.518,0,1,1-1.024,0V12.5H10.05a1.1,1.1,0,0,1-1.019-1.072l-.164-1.9a36.4,36.4,0,0,1-.023-5.955l.195-2.486A1.1,1.1,0,0,1,10.058,0H27.646a1.1,1.1,0,0,1,1.02,1.083l.195,2.486a36.4,36.4,0,0,1-.023,5.955l-.164,1.9A1.1,1.1,0,0,1,27.654,12.5H22.436ZM27.178,1.19H10.526a.549.549,0,0,0-.51.542L9.864,3.677a35.023,35.023,0,0,0-.019,5.208l.041.52L10,10.774a.548.548,0,0,0,.51.536h4.242V8.929a1.117,1.117,0,0,1,1.024-1.19h6.657a1.117,1.117,0,0,1,1.024,1.19V11.31h3.73a.548.548,0,0,0,.51-.536l.118-1.368A35.017,35.017,0,0,0,27.877,4.2l-.037-.52-.152-1.945a.549.549,0,0,0-.51-.541ZM21.924,8.929H16.292a.558.558,0,0,0-.512.6V11.31h6.657V9.524A.558.558,0,0,0,21.924,8.929ZM11.939,2.976a.838.838,0,0,1,.768.893.838.838,0,0,1-.768.893.838.838,0,0,1-.768-.893.838.838,0,0,1,.768-.893Zm2.56,0a.838.838,0,0,1,.768.893.777.777,0,1,1-1.536,0A.838.838,0,0,1,14.5,2.976Z",
            "transform": "translate(-6.352 3.571)"
          }
        }
      ]
    }
  ]
})
    }
  